export default {
	MOLLIE: 'MOLLIE'
};
